<template>
  <div class="card">
    <h2 class="card-title">Listado de noticias</h2>
    <DataTable
        ref="dataTable"
        :show-filter="true"
        :header="headers"
        :body="body"
        :actionButton="actionButton"
        :endpoint="NoticiasServices.api.getAll"
        :customFilters="{ tipo: tipoFilter }"
        @rowClicked="verNoticia"
    >
      <template #custom-filter>
        <div class="form-group mx-1" style="min-width: 180px">
          <label class="form-label">Tipo</label>
          <select class="form-control" v-model="tipoFilter" @change="$nextTick(() => $refs.dataTable.getFirstPageData())">
            <option value="">Todos</option>
            <option value="felicitaciones">Felicitación</option>
            <option value="luto">Luto</option>
            <option value="remember">Recordatorio</option>
            <option value="novedad">Novedad</option>
            <option value="interes">Información de interés</option>
            <option value="formulario">Formulario</option>
          </select>
        </div>
      </template>
    </DataTable>
  </div>
</template>
<script>
import TableList from "@/components/elements/TableList";
import { NoticiasServices } from "../services/NoticiasServices";
import DataTable from "@/components/elements/DataTable.vue";

export default {
  name: "ListarNoticias",
  computed: {
    NoticiasServices() {
      return NoticiasServices
    }
  },
  components: { TableList, DataTable },
  data() {
    return {
      tipoFilter: '',
      headers: NoticiasServices.headers(),
      body: NoticiasServices.body(),
      actionButton: {
        text: "Nueva noticia",
        action: () => {
          this.$router.push({name: 'CrearNoticia'})
        },
      },
    };
  },
  methods:{
    verNoticia(noticia){
      this.$router.push({ name: 'VerNoticia', params:{ id: noticia.id } })
    }
  }
};
</script>
